/*
 * @Author: your name
 * @Description:路由
 */
import Vue from "vue";
import VueRouter from "vue-router";
import home from "../common/Home.vue";
import store from "../store";
// 如果路由地址跳转相同, 且没有捕获到错误，控制台始终会出现警告
// push
const originalPush = VueRouter.prototype.push;
// replace
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/index.vue"),
    meta: { title: "登录" }
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "404" },
    component: () => import("@/views/404.vue")
  },
  {
    path: "/noPermission",
    name: "noPermission",
    meta: { title: "没有权限" },
    component: () => import("@/views/noPermission.vue")
  },
  {
    path: "/",
    component: home,
    children: [
      {
        path: "/home",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/home/Home.vue"),
        meta: { title: "首页" }
      },
      {
        path: "/orderList",
        name: "OrderList",
        component: () =>
          import(
            /* webpackChunkName: "orderList" */ "../views/orderManagement/orderList.vue"
          ),
        meta: { title: "订单列表" }
      },

      {
        path: "/customerManagement",
        name: "customerManagement",
        component: () =>
          import(
            /* webpackChunkName: "customerManagement" */ "../views/customerManagement/index.vue"
          ),
        meta: { title: "客户管理" }
      },
      {
        path: "/orderEntry",
        name: "orderEntry",
        component: () =>
          import("../views/orderEntry/orderEntry.vue"),
        meta: {
          title: "订单录入"
        }
      },
      {
        path: "/setting",
        name: "setting",
        component: () =>
          import("../views/setting/index.vue"),
        meta: {
          title: "站点设置"
        }
      },
      {
        path: "/advanceCharge",
        name: "AdvanceCharge",
        component: () =>
          import("../views/fund-management/advance-charge"),
        meta: {
          title: "预付款",
          requiresAuth: true
        }
      },
      {
        path: "/accountStatement",
        name: "AccountStatement",
        component: () =>
          import("../views/fund-management/AccountStatement.vue"),
        meta: {
          title: "对账单",
          requiresAuth: true
        }
      },
      {
        path: "/systemSwitch",
        name: "SystemSwitch",
        component: () =>
          import(/* webpackChunkName: "systemSwitch" */ "../views/systemSwitch/index.vue"),
        meta: {
          title: "系统切换",
          requiresAuth: true,
          requiresSwitching: true
        }
      }
    ]
  },
  {
    path: "*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const { token, user } = store.getters
  if (token) {
    if (to.matched.some((res) => res.meta.requiresAuth) && user.staffType !== 0) {
      next("/noPermission");
      return
    }
    if (to.matched.some((res) => res.meta.requiresSwitching) && !user.switching) {
      next("/noPermission");
      return
    }
    next();
  } else {
    if (to.name !== "login") {
      next("/login");
    } else {
      next();
    }
  }
});
// 解决Loading chunk (\d)+ failed问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload();
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }
});
export default router;
